import * as React from 'react';
import styles from './index.less';
import * as AHooks from 'ahooks';
import { FI18n, FServiceAPI } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import { Dropdown, Popover } from 'antd';
import FIcons from '@/components/FIcons';
import FSimpleBar from '../FSimpleBar';

interface FResourceTypeFilter2Props {
  value: {
    value: string;
    label: string;
    values: string[];
    labels: string[];
  };
  omitTheme?: boolean;

  onChange?(value: FResourceTypeFilter2Props['value']): void;

  // subjectType?: 'resource' | 'collection' | 'resource,collection';
  subjectTypeArr: Array<'resource' | 'collection' | 'exhibitCollection'>;
}

enum ESubjectType {
  resource = 1,
  collection = 4,
  exhibitCollection = 5,
}

interface Option {
  value: string;
  label: string;
  values: string[];
  labels: string[];
  children: Option[];
}

interface ServerData {
  code: string;
  name: string;
  children: ServerData[];
}

interface FResourceTypeFilterStates {
  _localRecently: {
    value: string;
    labels: string[];
  }[];
  $recommend: {
    value: string;
    labels: string[];
  }[];
  $options: Option[];
  _isOpen: boolean;
}

const initStates: FResourceTypeFilterStates = {
  _localRecently: [],
  $recommend: [],
  $options: [],
  _isOpen: false,
};

function FResourceTypeFilter2({
  value,
  omitTheme = false,
  onChange,
  subjectTypeArr,
}: FResourceTypeFilter2Props) {
  const [_localRecently, set_localRecently] = AHooks.useLocalStorageState<
    FResourceTypeFilterStates['_localRecently']
  >('FResourceTypeFilter-$localRecently', {
    defaultValue: initStates['_localRecently'],
  });
  const [$recommend, set$recommend] = React.useState<FResourceTypeFilterStates['$recommend']>(
    initStates['$recommend'],
  );
  const [$options, set$options] = React.useState<Option[]>(initStates['$options']);
  const [_isOpen, set_isOpen] = React.useState<FResourceTypeFilterStates['_isOpen']>(
    initStates['_isOpen'],
  );

  AHooks.useMount(async () => {
    const {
      data: data_resourceTypes,
    }: {
      data: ServerData[];
    } = await FServiceAPI.Resource.resourceTypes({
      category: 1,
      isMine: false,
      status: 1,
      // subjectType: subjectType === 'resource' ? 1 : subjectType === 'collection' ? 4 : '1,4',
      // @ts-ignore
      subjectType: subjectTypeArr
        .map((st) => {
          return ESubjectType[st as keyof typeof ESubjectType];
        })
        .join(','),
    });
    let data: ServerData[] = data_resourceTypes;
    if (omitTheme) {
      data = data.filter((d) => {
        return d.name !== '主题';
      });
    }
    const options: Option[] = handledData(data, null, subjectTypeArr);
    set$options(options);
  });

  AHooks.useMount(async () => {
    const {
      data: data_recently,
    }: {
      data: {
        code: string;
        name: string;
        names: string;
        resourceCount: number;
      }[];
    } = await FServiceAPI.Resource.listSimple4Recently({
      // subjectType: subjectType === 'resource' ? 1 : subjectType === 'collection' ? 4 : '1,4',
      subjectType: subjectTypeArr
        .map((st) => {
          return ESubjectType[st as keyof typeof ESubjectType];
        })
        .join(','),
    });
    if (!data_recently) {
      return;
    }
    set$recommend(
      data_recently
        .filter((r) => {
          return _localRecently.every((lr) => {
            return lr.value.replace('#all', '') !== r.code;
          });
        })
        .filter((r, i) => {
          return i < 6;
        })
        .map<FResourceTypeFilterStates['$recommend'][number]>((r) => {
          return {
            value: r.code,
            labels: r.names.split('/'),
          };
        }),
    );
  });

  AHooks.useUnmount(() => {});

  function onDropdownChange(op: Option) {
    if (op.value !== '#all') {
      set_localRecently([
        {
          value: op.value,
          labels: op.labels,
        },
        ..._localRecently
          .filter((i) => {
            return i.value !== op.value;
          })
          .filter((i, j) => {
            return j < 5;
          }),
      ]);
    }
    onChange && onChange(op);
    set_isOpen(false);
  }

  return (
    <Dropdown
      // open={true}
      open={_isOpen}
      onOpenChange={(o) => {
        set_isOpen(o);
      }}
      trigger={['hover']}
      overlayClassName={styles.overlayClassName}
      destroyPopupOnHide={true}
      overlay={
        <FSimpleBar maxHeight={540} width={'fit-content'}>
          <div className={styles.overlay}>
            {[..._localRecently, ...$recommend].length > 0 && (
              <>
                {subjectTypeArr.includes('resource') && (
                  <div className={styles.recommend}>
                    <FComponentsLib.FContentText
                      text={FI18n.i18nNext.t('filter_resourcetype_hint')}
                      type={'additional2'}
                    />
                    <div style={{ height: 20 }} />
                    <div className={styles.recommendResourceTypes}>
                      {[..._localRecently, ...$recommend]
                        .filter((_, i) => {
                          return i < 6;
                        })
                        .map((r) => {
                          const showLabels: string[] = r.labels.filter((l: string) => {
                            return l !== FI18n.i18nNext.t('filter_resourcetype_option_all');
                          });
                          return (
                            <label
                              onClick={() => {
                                onDropdownChange({
                                  value: r.value,
                                  values: [],
                                  labels: r.labels,
                                  label: '',
                                  children: [],
                                });
                              }}
                              key={r.value}
                            >
                              {showLabels.join('/') ||
                                // '全部'
                                FI18n.i18nNext.t('filter_resourcetype_option_all')}
                            </label>
                          );
                        })}
                    </div>
                  </div>
                )}

                {subjectTypeArr.includes('resource') && (
                  <>
                    <div style={{ padding: '0 20px' }}>
                      <FComponentsLib.FContentText
                        text={FI18n.i18nNext.t('filter_resourcetype_hint2')}
                        type={'additional2'}
                      />
                    </div>
                    <div style={{ height: 10 }} />
                  </>
                )}

                {subjectTypeArr.includes('collection') && <div style={{ height: 10 }} />}
              </>
            )}

            <div className={styles.FCascader}>
              {$options.map((o0) => {
                return (
                  <Popover
                    key={o0.value}
                    // getPopupContainer={() => {
                    // return ref.current;
                    // }}
                    zIndex={10000}
                    open={o0.children.length === 0 ? false : undefined}
                    overlayClassName={styles.PopoverOverlayClassName}
                    placement={'rightTop'}
                    title={null}
                    content={
                      <div className={styles.itemChildren}>
                        {o0.children.map((o1, o1Index, data) => {
                          return (
                            <React.Fragment key={o1.value}>
                              <Popover
                                zIndex={10001}
                                open={o1.children.length === 0 ? false : undefined}
                                overlayClassName={styles.PopoverOverlayClassName}
                                title={null}
                                placement={'rightTop'}
                                content={
                                  <div className={styles.itemChildren}>
                                    {o1.children.map((o2) => {
                                      return (
                                        <React.Fragment key={o2.value}>
                                          <Popover
                                            zIndex={10002}
                                            open={o2.children.length === 0 ? false : undefined}
                                            overlayClassName={styles.PopoverOverlayClassName}
                                            title={null}
                                            placement={'rightTop'}
                                            content={
                                              <div className={styles.itemChildren}>
                                                {o2.children.map((o3) => {
                                                  return (
                                                    <React.Fragment key={o3.value}>
                                                      <div
                                                        className={styles.item}
                                                        onClick={() => {
                                                          if (o3.children.length === 0) {
                                                            onDropdownChange(o3);
                                                          }
                                                        }}
                                                      >
                                                        <span>{o3.label}</span>

                                                        {o3.children.length > 0 && (
                                                          <FIcons.FRight
                                                            className={styles.itemRightIcon}
                                                          />
                                                        )}
                                                      </div>
                                                    </React.Fragment>
                                                  );
                                                })}
                                              </div>
                                            }
                                          >
                                            <div
                                              className={styles.item}
                                              onClick={() => {
                                                if (o2.children.length === 0) {
                                                  onDropdownChange(o2);
                                                }
                                              }}
                                            >
                                              <span>{o2.label}</span>

                                              {o2.children.length > 0 && (
                                                <FIcons.FRight className={styles.itemRightIcon} />
                                              )}
                                            </div>
                                          </Popover>
                                        </React.Fragment>
                                      );
                                    })}
                                  </div>
                                }
                              >
                                <div
                                  className={styles.item}
                                  onClick={() => {
                                    if (o1.children.length === 0) {
                                      onDropdownChange(o1);
                                    }
                                  }}
                                >
                                  <span>{o1.label}</span>
                                  {o1.children.length > 0 && (
                                    <FIcons.FRight className={styles.itemRightIcon} />
                                  )}
                                </div>
                              </Popover>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    }
                  >
                    <div
                      className={styles.item}
                      key={o0.value}
                      onClick={() => {
                        if (o0.children.length === 0) {
                          onDropdownChange(o0);
                        }
                      }}
                    >
                      <span>{o0.label}</span>
                      {o0.children.length > 0 && <FIcons.FRight className={styles.itemRightIcon} />}
                    </div>
                  </Popover>
                );
              })}
            </div>
            <div style={{ height: 10 }} />
          </div>
        </FSimpleBar>
      }
      autoAdjustOverflow={false}
    >
      <div className={styles.square}>
        <FComponentsLib.FContentText
          text={
            value.labels
              .filter((l) => {
                // return l !== '全部';
                return l !== FI18n.i18nNext.t('filter_resourcetype_option_all');
              })
              .join(' / ') ||
            // '全部'
            FI18n.i18nNext.t('filter_resourcetype_option_all')
          }
          type={'normal'}
        />
        {_isOpen ? (
          <FIcons.FUp style={{ fontSize: 12 }} />
        ) : (
          <FIcons.FDown style={{ fontSize: 12 }} />
        )}
      </div>
    </Dropdown>
  );
}

export default FResourceTypeFilter2;

function handledData(
  data: ServerData[],
  parent: Option | null,
  subjectTypeArr: Array<'resource' | 'collection' | 'exhibitCollection'>,
): Option[] {
  const result: Option[] = data.map((d) => {
    const res: Option = {
      value: d.code,
      label: d.name,
      values: [...(parent?.values || []), d.code],
      labels: [...(parent?.labels || []), d.name],
      children: [],
    };

    return {
      ...res,
      children: handledData(d.children, res, subjectTypeArr),
    };
  });
  if (result.length === 0) {
    return [];
  }

  if (parent) {
    result.unshift({
      value: parent.value + '#all',
      // label: '全部',
      label: FI18n.i18nNext.t('filter_resourcetype_option_all'),
      values: [...parent.values, parent.value + '#all'],
      labels: [
        ...parent.labels,
        //  '全部'
        FI18n.i18nNext.t('filter_resourcetype_option_all'),
      ],
      children: [],
    });
    if (subjectTypeArr.includes('resource')) {
      result.push({
        value: parent.value + '#other',
        // label: '其他',
        label: FI18n.i18nNext.t('filter_resourcetype_type_other'),
        values: [...parent.values, parent.value + '#other'],
        labels: [...parent.labels, FI18n.i18nNext.t('filter_resourcetype_type_other')],
        children: [],
      });
    }
  } else {
    result.unshift({
      value: '#all',
      // label: '全部',
      label: FI18n.i18nNext.t('filter_resourcetype_option_all'),
      values: ['#all'],
      labels: [
        // '全部'
        FI18n.i18nNext.t('filter_resourcetype_option_all'),
      ],
      children: [],
    });
  }
  return result;
}
